<template>
  <span class="count-item" :class="{ money: type == 1 }">
    <span class="label">{{ title }}</span>
    <span class="current-num">
      <template v-if="type == 1">{{ currentNum | currency(2) }}</template>
      <template v-else>{{ currentNum }}</template>
    </span>
    <i v-if="changeNum" :class="tagClass"></i>
    <span v-if="changeNum" class="change-num" :style="colorInfo">
      <template v-if="type == 1">{{
        Math.abs(changeNum) | currency(2)
      }}</template>
      <template v-else>{{ Math.abs(changeNum) }}</template>
    </span>
  </span>
</template>

<style lang="scss" scoped>
.count-item {
  display: flex;
  align-items: center;
  color: #333;
  &.money {
    .label {
      margin-right: 1rem;
    }
  }
  .label {
    margin-right: 0.5rem;
  }
  .current-num {
    max-width: 28%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  i {
    width: 1.2rem;
    height: 1.2rem;
    display: inline-block;
    margin-left: auto;
    &.up {
      background: url("../../assets/arrow-up@2x.png") center center no-repeat;
      background-size: cover;
    }
    &.down {
      background: url("../../assets/arrow-down@2x.png") center center no-repeat;
      background-size: cover;
    }
  }
  .change-num {
    max-width: 28%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>

<script>
export default {
  data() {
    return {};
  },
  props: {
    title: {},
    currentNum: {},
    changeNum: {},
    type: {},
  },
  watch: {
    $route() {},
  },
  computed: {
    tagClass() {
      if (this.changeNum) {
        if (this.changeNum > 0) {
          return "up";
        } else {
          return "down";
        }
      }
      return "";
    },
    colorInfo() {
      if (this.changeNum) {
        if (this.changeNum > 0) {
          return "color: #FF4D4F;";
        } else {
          return "color: #00B29C;";
        }
      }
      return "";
    },
  },
  components: {},
  methods: {},
  created() {},
};
</script>
